const Model = require("../types/Model");
const window = require("global");
const prop = require("prop");
const par = require("par");

const getSettingsPlugin = par(prop("plugins.aetonixsetting"), window);

module.exports = Model({
	name: "settingsopener",
	listeners
});

function listeners(){
	return {
		"mqtt:$/app/settings": handleOpenSettings
	};
}

function handleOpenSettings(){
	var plugin = getSettingsPlugin();
	if(!plugin) return;
	plugin.openSetting("settings", noop, noop);
}

function noop(){}